var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdutech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edutech",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19379",
    "data-name": "Path 19379",
    d: "M26.429,15h-17A2.429,2.429,0,0,0,7,17.429V28.357H28.857V17.429A2.429,2.429,0,0,0,26.429,15Zm-9.985,8.6a.607.607,0,1,1-.674,1.01l-3.643-2.429a.607.607,0,0,1,0-1.01l3.643-2.429a.607.607,0,1,1,.674,1.01l-2.885,1.923Zm7.286-1.419-3.643,2.429a.607.607,0,1,1-.674-1.01L22.3,21.679l-2.885-1.923a.607.607,0,1,1,.674-1.01l3.643,2.429a.607.607,0,0,1,0,1.01Z",
    transform: "translate(1.071 2.786)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19380",
    "data-name": "Path 19380",
    d: "M6.857,13.429a2.429,2.429,0,1,0-3.643,2.091v7.624a1.214,1.214,0,0,0,1.214,1.214H6.857V21.929H5.643V15.519A2.421,2.421,0,0,0,6.857,13.429Z",
    transform: "translate(0 1.929)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19381",
    "data-name": "Path 19381",
    d: "M16.429,2a2.421,2.421,0,0,0-1.214,4.519V16.571h2.429V6.519A2.421,2.421,0,0,0,16.429,2Z",
    transform: "translate(2.571 0)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19382",
    "data-name": "Path 19382",
    d: "M30.857,13.429a2.429,2.429,0,1,0-3.643,2.091v6.409H26v2.429h2.429a1.214,1.214,0,0,0,1.214-1.214V15.519A2.421,2.421,0,0,0,30.857,13.429Z",
    transform: "translate(5.143 1.929)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19383",
    "data-name": "Path 19383",
    d: "M13.286,10.5H9.643V6.519a2.429,2.429,0,1,0-2.429,0v5.2a1.214,1.214,0,0,0,1.214,1.214h3.643v3.643H14.5V11.714A1.214,1.214,0,0,0,13.286,10.5Z",
    transform: "translate(0.857 0)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19384",
    "data-name": "Path 19384",
    d: "M27.5,4.429a2.429,2.429,0,1,0-3.643,2.091V10.5H20.214A1.214,1.214,0,0,0,19,11.714v4.857h2.429V12.929h3.643a1.214,1.214,0,0,0,1.214-1.214v-5.2A2.421,2.421,0,0,0,27.5,4.429Z",
    transform: "translate(3.643 0)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19385",
    "data-name": "Path 19385",
    d: "M28.071,30.643H8.643A3.643,3.643,0,0,1,5,27H31.714A3.643,3.643,0,0,1,28.071,30.643Z",
    transform: "translate(0.643 5.357)",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdutech);
export default __webpack_public_path__ + "static/media/edutech.f665830ce3eda1f4de55d4275c5f8eb6.svg";
export { ForwardRef as ReactComponent };